import { render } from "./TypesTree.vue?vue&type=template&id=e0f4aee8"
import script from "./TypesTree.vue?vue&type=script&lang=js"
export * from "./TypesTree.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__